import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany } from '@apexdesigner/schema-tools';

export const tenant = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z.string().describe('Display name for the tenant'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Optional description of the tenant'),

    tenantAssignments: hasMany('TenantAssignment'),

    processDesigns: hasMany('ProcessDesign'),

    processDesignHistories: hasMany('ProcessDesignHistory'),

    processInstances: hasMany('ProcessInstance'),

    processInstanceHistories: hasMany('ProcessInstanceHistory'),

    pendingStateUpdates: hasMany('PendingStateUpdate'),

    tokens: hasMany('Token'),

    tokenHistories: hasMany('TokenHistory'),

    tokenLinks: hasMany('TokenLink'),

    userTasks: hasMany('UserTask'),

    userTaskHistories: hasMany('UserTaskHistory'),

    serviceTasks: hasMany('ServiceTask'),

    serviceTaskHistories: hasMany('ServiceTaskHistory'),

    timers: hasMany('Timer'),

    messageListeners: hasMany('MessageListener'),

    conditionWatchers: hasMany('ConditionWatcher'),

    activityMappings: hasMany('ActivityMapping'),

    latestProcessDesigns: hasMany('LatestProcessDesign'),

    processDesignActivityCounts: hasMany('ProcessDesignActivityCount'),

    myUserTasks: hasMany('MyUserTask'),

    processInstanceSummaries: hasMany('ProcessInstanceSummary'),
  })
  .describe(
    'The tenant root for multi-tenancy. Each tenant represents an\norganization whose process data is isolated from other tenants.',
  )
  .as('Tenant');

export { tenant as tenantSchema };
